const defaultFetch = typeof window !== "undefined" ? window.fetch : undefined;
export class RuntimeServiceHelper {
    env;
    fetch;
    constructor(env, fetch = defaultFetch){
        this.env = env;
        this.fetch = fetch;
    }
    liveURL(fileId) {
        return `${this.env.services["@superwall-editor/runtime"].baseURL}/live/document/${fileId}`;
    }
    storeURL(fileId) {
        return `${this.env.services["@superwall-editor/runtime"].baseURL}/store/document/${fileId}`;
    }
    async storeAndGetURL(fileId) {
        if (this.env.services["@superwall-editor/runtime"].baseURL.includes("/dev/dev")) {
            return this.liveURL(fileId);
        }
        // We're going to load the store url & get the redirect
        const url = this.storeURL(fileId);
        console.log("Fetching store url", url);
        const headers = await this.fetch(url, {
            redirect: "manual"
        }).then((res)=>res.headers);
        console.log("Got store url", headers);
        if (!headers || !headers.get("location")) {
            throw new Error("Failed to get store url");
        }
        return headers.get("location");
    }
}
export class EditorServiceHelper {
    env;
    constructor(env){
        this.env = env;
    }
    editorURL({ paywallId, applicationId, version = "latest" }) {
        if (this.env.services["@superwall-editor/editor"].baseURL.includes("/dev/dev")) {
            return `${this.env.services["@superwall-editor/editor"].baseURL}/#/applications/${applicationId}/paywalls/${paywallId}/${version}`;
        }
        // When we're in production we'll send
        // `/editor/#/applications/5/paywalls/28/latest`
        return `/editor/#/applications/${applicationId}/paywalls/${paywallId}/${version}`;
    }
}
